import Vue from 'vue'
import VueRouter from 'vue-router'
import { onAuthStateChanged } from 'firebase/auth'
import { doc, getDoc } from 'firebase/firestore'
import { auth, db } from '@/firebase'
import HomeView from '../views/HomeView.vue'

Vue.use(VueRouter)

const routes = [

  {
    path: '/login',
    name: 'login',
    component: () => import('../views/LoginView.vue'),
  },
  {
    path: '/reset-password',
    name: 'reset-password',
    component: () => import('../views/ResetPasswordView.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('../views/Privacy.vue'),
  },
  {
    path: '/terms',
    name: 'terms',
    component: () => import('../views/Terms.vue'),
  },
  {
    path: '/cookies',
    name: 'cookies',
    component: () => import('../views/Cookies.vue'),
  },
  {
    path: '/demo',
    name: 'demo',
    component: () => import('../views/DemoView.vue'),
  },
  {
    path: '/why',
    name: 'why',
    component: () => import('../views/WhyView.vue'),
  },
  {
    path: '/pricing',
    name: 'pricing',
    component: () => import('../views/PricingView.vue'),
  },
  {
    path: '/features',
    name: 'features',
    component: () => import('../views/FeaturesView.vue'),
  },
  {
    path: '/documentation',
    name: 'documentation',
    component: () => import('../views/DocumentationView.vue'),
  },
  {
    path: '/help',
    name: 'help',
    component: () => import('../views/HelpCenterView.vue'),
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/ContactView.vue'),
  },
  {
    path: '/security',
    name: 'security',
    component: () => import('../views/SecurityView.vue'),
  },
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/admin',
    name: 'admin',
    component: () => import('../views/AdminDashboardView.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/admin/customers/:id',
    name: 'admin-customer-detail',
    component: () => import('../views/CustomerDetailView.vue'),
    props: true,
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/admin/templates',
    name: 'admin-templates',
    component: () => import('../views/AdminTemplates.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/admin/products',
    name: 'AdminProducts',
    component: () => import('../views/AdminProducts.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/manage-app-progress',
    name: 'ManageAppProgress',
    component: () => import('../views/ManageAppProgressView.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/admin-settings',
    name: 'admin-settings',
    component: () => import('../views/AdminSettingsView.vue'),
    meta: { requiresAuth: true, role: 'Admin' }
  },
  {
    path: '/staff-dashboard',
    name: 'StaffDashboard',
    component: () => import('../views/StaffDashboardView.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-leads',
    name: 'StaffLeads',
    component: () => import('../views/StaffLeads.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-payments',
    name: 'StaffPayments',
    component: () => import('../views/StaffPaymentsView.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff/templates',
    name: 'staff-templates',
    component: () => import('../views/StaffTemplates.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-onboard-customer',
    name: 'StaffOnboardCustomer',
    component: () => import('../views/StaffOnboardCustomerView'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff/products',
    name: 'StaffProducts',
    component: () => import('../views/StaffProducts.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff/products/:id',
    name: 'StaffProductDetail',
    component: () => import('../views/StaffProductDetail.vue'),
    props: true,
    meta: { requiresAuth: true, role: 'Staff' }
  },
  {
    path: '/staff-manage-settings',
    name: 'StaffManageSettings',
    component: () => import( '../views/StaffManageSettingsView.vue'),
    meta: { requiresAuth: true, role: 'Staff' }
  },
  { path: '/blog', name: 'Blog', component: () => import('@/views/BlogView.vue') },
{ path: '/blog/:slug', name: 'BlogPost', component: () => import('@/views/BlogPostView.vue') },
{ path: '/staff-blog', name: 'StaffBlogManage', component: () => import('@/views/StaffBlogManageView.vue'), meta: { requiresStaff: true } },
{ path: '/admin/revenue-reports', name: 'AdminRevenueReportsView', component: () => import('@/views/AdminRevenueReportsView.vue'), meta: { requiresStaff: true } },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import( '../views/CustomerDashboardView.vue'),
    meta: { requiresAuth: true, role: 'Customer' }
  },
  {
    path: '/customer-settings',
    name: 'customer-settings',
    component: () => import('../views/CustomerSettingsView.vue'),
    meta: { requiresAuth: true, role: 'Customer' }
  },
  {
    path: '/about',
    name: 'about',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: function () {
      return import(/* webpackChunkName: "about" */ '../views/AboutView.vue')
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  // New pages start at the top; links like /#pricing scroll smoothly to that section.
  scrollBehavior(to, from, saved) {
    if (saved) return saved
    if (to.hash) return { selector: to.hash, behavior: 'smooth', offset: { x: 0, y: 80 } }
    return { x: 0, y: 0 }
  }
})

// ── Sign-in check for the pages behind the login ────────────────────
// Public pages are untouched. Pages marked requiresAuth / requiresStaff
// need a signed-in account with the right role (users/{uid}.role):
//   Admin    → every internal page
//   Staff    → staff pages
//   Customer → the customer dashboard and settings
// Anyone else is sent to /login. This doesn't change how signing in works.
let authReadyPromise = null
function currentUser() {
  if (!authReadyPromise) {
    authReadyPromise = new Promise((resolve) => {
      const stop = onAuthStateChanged(auth, (u) => { stop(); resolve(u) })
    })
  }
  return authReadyPromise.then(() => auth.currentUser)
}

router.beforeEach(async (to, from, next) => {
  const needsStaff = to.matched.some(r => r.meta && r.meta.requiresStaff)
  const needsAuth = needsStaff || to.matched.some(r => r.meta && r.meta.requiresAuth)
  if (!needsAuth) return next()

  const user = await currentUser()
  if (!user) return next({ path: '/login', query: { redirect: to.fullPath } })

  const wanted = needsStaff ? 'Staff' : (to.matched.map(r => r.meta && r.meta.role).filter(Boolean).pop() || null)
  if (!wanted) return next()
  try {
    const snap = await getDoc(doc(db, 'users', user.uid))
    const role = snap.exists() ? (snap.data().role || 'Customer') : 'Customer'
    if (role === 'Admin' || role === wanted) return next()
    const home = role === 'Staff' ? '/staff-dashboard' : role === 'Customer' ? '/dashboard' : '/login'
    return next(home === to.path ? '/login' : home)
  } catch (e) {
    return next('/login')
  }
})

export default router